<template>
<div class="modal fade newAttendanceModal" id="attendanceModalId" tabindex="-1" role="dialog" aria-labelledby="newAttendanceModal" aria-hidden="true">
<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <form  @submit.prevent="submit">
      <div   class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Shift-in Records For {{selectedUser.firstName}} </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="" v-if="loading">
          <!-- Show the loader when async operation is going on -->
          <div class="loader"></div>
        </div>

        <div v-else>
          <template v-if="leaveView">
            <button  class="btn btn-secondary text-white left" type="button" @click="leaveView=false">Add Leaves</button>
            <button class="btn btn-secondary  text-white ml-4"  @click="shiftOut" type="button" v-if="shiftData.isPresent">Shift out User</button>
          </template>

          <button v-else class="btn btn-secondary text-white pull-right" type="button" @click="leaveView=true">Manage Shift-in Records</button>
          <template v-if="leaveView">

          <div class="row mt-10  " v-if="leave.length" >
            <perfect-scrollbar class="scroll-area-attendance col-md-12">
            <div class="col-md-12">
              <h6 class="text-left">Leave List</h6>
            </div>
              <div class="row">
            <div class="mt-10 col-md-4 d-flex justify-content-center border-bottom border-grey" v-for="(item, index) in sortedLeaveRecord" :key="index" >
                   <span class="pl-15 text-primary d-flex justify-content-center align-items-center">
                     <div>{{ item }}</div>
              </span>
            </div>
            </div>
            </perfect-scrollbar>
          </div>
          <table  class="mt-10 table table-bordered">
            <thead class="text-primary">
            <tr>
              <th class="text-center">Toggle 		<i class="fa fa-question-circle text-primary" data-toggle="tooltip" data-placement="top" title="Days that are marked as checked will be considered as working days."></i></th>
              <th class="text-center">Day</th>
              <th class="text-center">Start Shift</th>
              <th class="text-center">End Shift</th>
            </tr>
            </thead>
            <tbody >
            <tr>
              <td class="text-center">
                <input class="mt-12" type="checkbox" aria-label="Checkbox for following text input" v-model="attendanceDataV2.Monday.type" @click="modifyDetails(attendanceDataV2.Monday)">
              </td>
              <td class="text-center">
                <label class="mb-0 mt-12 font-weight-bold">Monday</label>
              </td>
              <td class="form-group mt-5">
                <select class="form-control" v-model="attendanceDataV2.Monday.shiftIn" :disabled="!attendanceDataV2.Monday.type">
                  <option v-for="time in timeOptions" :key="time" :value="time">{{ time }}</option>
                </select>
              </td>
              <td class="form-group mt-5">
                <div class="d-flex">
                  <select class="form-control mr-10" v-model="attendanceDataV2.Monday.daySelection" :disabled="!attendanceDataV2.Monday.type">
                    <option value="sameDay">Same Day</option>
                    <option value="nextDay">Next Day</option>
                  </select>
                  <select class="form-control" v-model="attendanceDataV2.Monday.shiftOut" :disabled="!attendanceDataV2.Monday.type">
                    <option v-for="time in timeOptions" :key="time" :value="time">{{ time }}</option>
                  </select>
                </div>
              </td>
            </tr>
            <tr>
              <td class="text-center">
                <input class="mt-12" type="checkbox" aria-label="Checkbox for following text input" v-model="attendanceDataV2.Tuesday.type" @click="modifyDetails(attendanceDataV2.Tuesday)">
              </td>
              <td class="text-center">
                <label class="mb-0 mt-12 font-weight-bold">Tuesday</label>
              </td>
              <td class="form-group mt-5">
                <select class="form-control" v-model="attendanceDataV2.Tuesday.shiftIn" :disabled="!attendanceDataV2.Tuesday.type">
                  <option v-for="time in timeOptions" :key="time" :value="time">{{ time }}</option>
                </select>
              </td>
              <td class="form-group mt-5">
                <div class="d-flex">
                  <select class="form-control mr-10" v-model="attendanceDataV2.Tuesday.daySelection" :disabled="!attendanceDataV2.Tuesday.type">
                    <option value="sameDay">Same Day</option>
                    <option value="nextDay">Next Day</option>
                  </select>
                  <select class="form-control" v-model="attendanceDataV2.Tuesday.shiftOut" :disabled="!attendanceDataV2.Tuesday.type">
                    <option v-for="time in timeOptions" :key="time" :value="time">{{ time }}</option>
                  </select>
                </div>

              </td>
            </tr>
            <tr>
              <td class="text-center">
                <input class="mt-12" type="checkbox" aria-label="Checkbox for following text input" v-model="attendanceDataV2.Wednesday.type" @click="modifyDetails(attendanceDataV2.Wednesday)">
              </td>
              <td class="text-center">
                <label class="mb-0 mt-12 font-weight-bold">Wednesday</label>
              </td>
              <td class="form-group mt-5">
                <select class="form-control" v-model="attendanceDataV2.Wednesday.shiftIn" :disabled="!attendanceDataV2.Wednesday.type">
                  <option v-for="time in timeOptions" :key="time" :value="time">{{ time }}</option>
                </select>
              </td>
              <td class="form-group mt-5">
                <div class="d-flex">
                  <select class="form-control mr-10" v-model="attendanceDataV2.Wednesday.daySelection" :disabled="!attendanceDataV2.Wednesday.type">
                    <option value="sameDay">Same Day</option>
                    <option value="nextDay">Next Day</option>
                  </select>
                  <select class="form-control" v-model="attendanceDataV2.Wednesday.shiftOut" :disabled="!attendanceDataV2.Wednesday.type">
                    <option v-for="time in timeOptions" :key="time" :value="time">{{ time }}</option>
                  </select>
                </div>
              </td>
            </tr>
            <tr>
              <td class="text-center">
                <input class="mt-12" type="checkbox" aria-label="Checkbox for following text input" v-model="attendanceDataV2.Thursday.type" @click="modifyDetails(attendanceDataV2.Thursday)">
              </td>
              <td class="text-center">
                <label class="mb-0 mt-12 font-weight-bold">Thursday</label>
              </td>
              <td class="form-group mt-5">
                <select class="form-control" v-model="attendanceDataV2.Thursday.shiftIn" :disabled="!attendanceDataV2.Thursday.type">
                  <option v-for="time in timeOptions" :key="time" :value="time">{{ time }}</option>
                </select>
              </td>
              <td class="form-group mt-5">
                <div class="d-flex">
                  <select class="form-control mr-10" v-model="attendanceDataV2.Thursday.daySelection" :disabled="!attendanceDataV2.Thursday.type">
                    <option value="sameDay">Same Day</option>
                    <option value="nextDay">Next Day</option>
                  </select>
                  <select class="form-control" v-model="attendanceDataV2.Thursday.shiftOut" :disabled="!attendanceDataV2.Thursday.type">
                    <option v-for="time in timeOptions" :key="time" :value="time">{{ time }}</option>
                  </select>
                </div>

              </td>
            </tr>
            <tr>
              <td class="text-center">
                <input class="mt-12" type="checkbox" aria-label="Checkbox for following text input" v-model="attendanceDataV2.Friday.type" @click="modifyDetails(attendanceDataV2.Friday)">
              </td>
              <td class="text-center">
                <label class="mb-0 mt-12 font-weight-bold">Friday</label>
              </td>
              <td class="form-group mt-5">
                <select class="form-control" v-model="attendanceDataV2.Friday.shiftIn" :disabled="!attendanceDataV2.Friday.type">
                  <option v-for="time in timeOptions" :key="time" :value="time">{{ time }}</option>
                </select>
              </td>
              <td class="form-group mt-5">
                <div class="d-flex">
                  <select class="form-control mr-10" v-model="attendanceDataV2.Friday.daySelection" :disabled="!attendanceDataV2.Friday.type">
                    <option value="sameDay">Same Day</option>
                    <option value="nextDay">Next Day</option>
                  </select>
                  <select class="form-control" v-model="attendanceDataV2.Friday.shiftOut" :disabled="!attendanceDataV2.Friday.type">
                    <option v-for="time in timeOptions" :key="time" :value="time">{{ time }}</option>
                  </select>
                </div>
              </td>
            </tr>
            <tr>
              <td class="text-center">
                <input class="mt-12" type="checkbox" aria-label="Checkbox for following text input" v-model="attendanceDataV2.Saturday.type" @click="modifyDetails(attendanceDataV2.Saturday)">
              </td>
              <td class="text-center">
                <label class="mb-0 mt-12 font-weight-bold">Saturday</label>
              </td>
              <td class="form-group mt-5">
                <select class="form-control" v-model="attendanceDataV2.Saturday.shiftIn" :disabled="!attendanceDataV2.Saturday.type">
                  <option v-for="time in timeOptions" :key="time" :value="time">{{ time }}</option>
                </select>
              </td>
              <td class="form-group mt-5">
                <div class="d-flex">
                  <select class="form-control mr-10" v-model="attendanceDataV2.Saturday.daySelection" :disabled="!attendanceDataV2.Saturday.type">
                    <option value="sameDay">Same Day</option>
                    <option value="nextDay">Next Day</option>
                    <option value="custom">Custom (After Two Weeks)</option>
                  </select>
                  <input v-if="attendanceDataV2.Saturday.daySelection === 'custom'" :disabled="!attendanceDataV2.Saturday.type" v-model="attendanceDataV2.Saturday.nextDate" :min="getCurrentTime" class="form-control mr-10" type="date">
                  <select class="form-control" v-model="attendanceDataV2.Saturday.shiftOut" :disabled="!attendanceDataV2.Saturday.type">
                    <option v-for="time in timeOptions" :key="time" :value="time">{{ time }}</option>
                  </select>
                </div>
              </td>
            </tr>
            <tr>
              <td class="text-center">
                <input class="mt-12" type="checkbox" aria-label="Checkbox for following text input" v-model="attendanceDataV2.Sunday.type" @click="modifyDetails(attendanceDataV2.Sunday)">
              </td>
              <td class="text-center">
                <label class="mb-0 mt-12 font-weight-bold">Sunday</label>
              </td>
              <td class="form-group mt-5">
                <select class="form-control" v-model="attendanceDataV2.Sunday.shiftIn" :disabled="!attendanceDataV2.Sunday.type">
                  <option v-for="time in timeOptions" :key="time" :value="time">{{ time }}</option>
                </select>
              </td>
              <td class="form-group mt-5">
                <div class="d-flex">
                  <select class="form-control mr-10" v-model="attendanceDataV2.Sunday.daySelection" :disabled="!attendanceDataV2.Sunday.type">
                    <option value="sameDay">Same Day</option>
                    <option value="nextDay">Next Day</option>
                    <option value="custom">Custom (After Two Weeks)</option>
                  </select>
                  <input v-if="attendanceDataV2.Sunday.daySelection === 'custom'" :disabled="!attendanceDataV2.Sunday.type" v-model="attendanceDataV2.Sunday.nextDate" :min="getCurrentTime" class="form-control mr-10" type="date">
                  <select class="form-control" v-model="attendanceDataV2.Sunday.shiftOut" :disabled="!attendanceDataV2.Sunday.type">
                    <option v-for="time in timeOptions" :key="time" :value="time">{{ time }}</option>
                  </select>
                </div>

              </td>
            </tr>
            </tbody>
          </table>
          </template>
          <div v-else class="container">
            <div class="container d-flex justify-content-between align-items-center">
            <date-range-picker
              class="w-100"
              ref="picker"
              :showDropdowns="true"
              v-model="searchQuery.dateRange"
          >
            <template v-slot:input="picker" style="min-width: 350px;">
              {{ (picker.startDate) ? formattedDateWithOutTime(picker.startDate) + ' - ' + formattedDateWithOutTime(picker.endDate) : 'Select Date range' }}
            </template>
          </date-range-picker>
              <button class="btn btn-light m-0 border-0" type="button" @click="addLeaves" :disabled="!searchQuery.dateRange.startDate"><i class="fa fa-plus-circle fa-2x "></i> </button>
              <div class="text-danger" @click="leave=[]" ><i class="fa fa fa-remove fa-2x "></i> </div>
            </div>
            <div class="row mt-10" v-if="leave.length" >
            <div class="col-md-4 d-flex justify-content-center" v-for="(item, index) in sortedLeaveRecord" :key="index" >
                   <span class="badge badge-pill badge-success d-flex justify-content-center align-items-center">
                     <div>{{ item }}</div>
                 <button type="button" class="close pull-right" style="color: red; font-size: 20px" data-dismiss="alert" aria-label="Close" @click="removeLeave(index)" >
                   <span aria-hidden="true" >&times;</span>
                 </button>
              </span>
            </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-between">
        <button type="button" class="btn btn-secondary btn-sm ml-25"  data-dismiss="modal" aria-label="Close">Close</button>
        <button type="submit" class="btn btn-primary btn-sm mr-25" >
          <div class="loader small_loader" v-if="adding"></div>
          <span v-else>Submit</span>
        </button>
      </div>
    </form>
  </div>
</div>
</div>
</template>
<script >
import {db} from "@/firebase/init";
import swal from "sweetalert2";
import dateMixin from "@/mixins/dateMixin";
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import {PerfectScrollbar} from "vue2-perfect-scrollbar";
import moment from "moment-timezone";
export default {
  name: "AttendanceModal",
  mixins: [dateMixin],
  components: { DateRangePicker,PerfectScrollbar },
  data() {
    return {
      leaveView: true,
      loading: false,
      adding: false,
      selectedUser: {},
      timeOptions: this.generateTimeOptions(),
      shiftData: {
        presentShiftId: null,
        isPresent: false,
      },
      attendanceData:[
        {
          dayNumber: 1,
          day: 'Monday',
          type: false,
          shiftIn: null,
          shiftOut: null,
        },
        {
          dayNumber: 2,
          day: 'Tuesday',
          type: false,
          shiftIn: null,
          shiftOut: null,
        },
        {
          dayNumber: 3,
          day: 'Wednesday',
          type: false,
          shiftIn: null,
          shiftOut: null,
        },
        {
          dayNumber: 4,
          day: 'Thursday',
          type: false,
          shiftIn: null,
          shiftOut: null,
        },
        {
          dayNumber: 5,
          day: 'Friday',
          type: false,
          shiftIn: null,
          shiftOut: null,
        },
        {
          dayNumber: 6,
          day: 'Saturday',
          type: false,
          shiftIn: null,
          shiftOut: null,
        },
        {
          dayNumber: 7,
          day: 'Sunday',
          type: false,
          shiftIn: null,
          shiftOut: null,
        },
      ],
      attendanceDataV2: {
        Monday: {
          dayNumber: 1,
          day: 'Monday',
          type: false,
          shiftIn: null,
          shiftOut: null,
        },
        Tuesday: {
          dayNumber: 2,
          day: 'Tuesday',
          type: false,
          shiftIn: null,
          shiftOut: null,
          daySelection: 'sameDay'
        },
        Wednesday: {
          dayNumber: 3,
          day: 'Wednesday',
          type: false,
          shiftIn: null,
          shiftOut: null,
        },
        Thursday: {
          dayNumber: 4,
          day: 'Thursday',
          type: false,
          shiftIn: null,
          shiftOut: null,
        },
        Friday: {
          dayNumber: 5,
          day: 'Friday',
          type: false,
          shiftIn: null,
          shiftOut: null,
        },
        Saturday: {
          dayNumber: 6,
          day: 'Saturday',
          type: false,
          shiftIn: null,
          shiftOut: null,
        },
        Sunday: {
          dayNumber: 7,
          day: 'Sunday',
          type: false,
          shiftIn: null,
          shiftOut: null,
        },
      },
      leave: [],
      flagToCreateNewDoc: false,
      automaticShiftInDate: '',
      searchQuery: {
        dateRange: {
          startDate: null,
          endDate: null
        }
      },
    }
  },
  computed: {
    sortedLeaveRecord (){
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.leave.sort((a, b) =>{
        const dateA = new Date(a);
        const dateB = new Date(b);
        if (dateA < dateB) {
          return -1;
        } else if (dateA > dateB) {
          return 1;
        } else {
          return 0;
        }});
    },
    user() {
      return this.$store.getters.user;
    },
    getCurrentTime(){
      return moment().tz('America/New_York').format('YYYY-MM-DD');

    },
  },
  methods:{
    async shiftInformation(){
      try{
      const ref = await db.collection('attendance')
            .where('status', '==', true)
            .where('userUid', '==', this.selectedUser.docID)
            .get()

      if(!ref.size){
        this.shiftData.isPresent= false
        this.shiftData.presentShiftId = null
        return
      }
      ref.forEach(el => {
        this.shiftData.presentShiftId = el.id
      })
      this.shiftData.isPresent= true}
      catch(e){
        console.log('Error in fetching the user shift in record', e.toString())
      }
    },
    async shiftOut(){
      try{
        const ref = await db.collection('attendance').doc(this.shiftData.presentShiftId).get();
        const {status} = ref.data()
        if(!status){
          await swal('Error', 'The user has already logged out of their shift.!', 'error')
          return
        }
        await db.collection('attendance').doc(this.shiftData.presentShiftId).update({
          checkOutTime: new Date().toISOString(),
          status: false,
        })
        const blocks = [
          {
            "type": "context",
            "elements": [
              {
                "type": "plain_text",
                "text": `${this.selectedUser.firstName} ${this.selectedUser.lastName}  has been forcefully signed out from their shift by ${this.user.firstName} ${this.user.lastName}`,
                "emoji": true
              }
            ]
          }
        ]
        await this.$http.post('/slack/send_slack_message', {
          blocks,
          type: 'teamchat',
          grant_type: 'token'
        })
        this.$http.post('/utilities/update-availability-status', {
          email: this.selectedUser.email,
          grant_type: "token",
          event: 'shift_out',
        })

        await swal('Success', 'User has been logged out from their shift!', 'success')

      }
      catch(e){
        console.log('Error in forcefully shifting out the user')
      }
    },
    modifyDetails(value){
      value.shiftIn= value.type ? null : value.shiftIn ;
      value.shiftOut= value.type ? null : value.shiftOut;
    },
    removeLeave(index){
      this.leave.splice(index, 1);
    },
    generateDateList() {
      let currentDate = new Date(this.searchQuery.dateRange.startDate);
      while (currentDate <= this.searchQuery.dateRange.endDate) {
        const date =this.formattedDateWithOutTime(new Date(currentDate));
        if(!this.leave.includes(date)){
          this.leave.push(date)
        }
        currentDate.setDate(currentDate.getDate() + 1);
        console.log(this.leave)
      }
    },
    addLeaves(){
      this.generateDateList()
      this.searchQuery.dateRange={
        startDate: null,
        endDate: null
      }
    },
    generateTimeOptions() {
      const options = [];
      for (let i = 0; i < 24; i++) {
        for (let j = 0; j < 60; j += 30) {
          const hour = i.toString().padStart(2, '0');
          const minute = j.toString().padStart(2, '0');
          options.push(`${hour}:${minute}`);
        }
      }
      return options;
    },
    openModal(user){
      this.loading= true
       $('[data-toggle="tooltip"]').tooltip();
      this.selectedUser= user;
      this.leaveView= true;
      this.leave= []


      this.shiftInformation();
      this.fetchPreviousData();

      // this.fixAdminShiftsCollection();   //script to fix previous records for prod.
      $('#attendanceModalId').modal('show');
      $('.modal-backdrop').removeClass("modal-backdrop");
    },
    async fetchPreviousData(){
      try{
        const ref= await db.collection('admin-shifts').doc(this.selectedUser.docID).get()
        if(ref.exists){
          console.log(ref.data().shifts)
          const shifts = ref.data().shifts
          this.attendanceDataV2 = Object.keys(shifts).reduce(function (acc, key) {
            acc[key] = {
              nextDate: shifts[key].nextDate !== undefined ? shifts[key].nextDate : 'null',
              dayNumber: shifts[key].dayNumber !== undefined ? shifts[key].dayNumber : null,
              day: shifts[key].day !== undefined ? shifts[key].day : null,
              type: shifts[key].type !== undefined ? shifts[key].type : null,
              shiftIn: shifts[key].shiftIn !== undefined ? shifts[key].shiftIn : null,
              shiftOut: shifts[key].shiftOut !== undefined ? shifts[key].shiftOut : null,
              daySelection: shifts[key].daySelection !== undefined ? shifts[key].daySelection || 'sameDay' : 'sameDay',
            };
            return acc;
          }, {});

          this.leave = ref.data().leave ? ref.data().leave : []
          this.automaticShiftInDate = ref.data().automaticShiftInDate ? ref.data().automaticShiftInDate : ''
        }
        else{
          Object.entries(this.attendanceDataV2).forEach((value)=>{
            value[1].shiftIn=null;
            value[1].shiftOut=null;
            value[1].type= false;
          })
          this.flagToCreateNewDoc = true;
        }
        this.loading= false
      }
      catch(e){
        console.log('Error While fetching records', e.toString())
      }

    },
    async fixAdminShiftsCollection(){
      try{
        const shiftRef = await db.collection('admin-shifts').get();
        if(shiftRef.size){
          for (const doc of shiftRef.docs) {
            const data = doc.data();
            const shifts = data.shifts || []
            console.log('previous shifts for', data.email , shifts)

            Object.entries(this.attendanceDataV2).forEach(([key, value])=>{
              const requiredShift = shifts.find((d) => d.day === key) || {};
              console.log('shifts for', data.email , requiredShift , 'value')
              this.attendanceDataV2[key] = requiredShift;
              console.log(this.attendanceDataV2[key] , 'new values');
            })

            await db.collection('admin-shifts').doc(doc.id).update(
                {
                  shifts: this.attendanceDataV2,
                  shift2: null
                }
            )
            console.log('db updated for ', data.email)
          }
        }
      }
      catch(e){
        console.log(e.toString(), 'Error in fixing')
      }


    },
    async submit(){
      try{
        this.adding = true;
        let department = ''
        const ref = await db.collection('users').doc(this.selectedUser.docID).get();
        if(ref.exists) {
          department = ref.data().department;
        }
        if(this.flagToCreateNewDoc){
          await db.collection('admin-shifts').doc(this.selectedUser.docID).set({
            firstName: this.selectedUser.firstName,
            lastName: this.selectedUser.lastName,
            email: this.selectedUser.email,
            shifts: this.attendanceDataV2,
            leave: this.leave,
            automaticShiftInDate:this.automaticShiftInDate,
            department
          })
        }
        else{
          await db.collection('admin-shifts').doc(this.selectedUser.docID).update({
            firstName: this.selectedUser.firstName,
            lastName: this.selectedUser.lastName,
            email: this.selectedUser.email,
            shifts: this.attendanceDataV2,
            leave: this.leave,
            automaticShiftInDate:this.automaticShiftInDate,
            department
          })
        }
        await swal('Success', 'Records have been added!', 'success')
      }
      catch(e){
        console.log('error inserting attendance records', e.toString())
        await swal('Error', 'Something went wrong while deleting task out!' + e.toString(), 'error');
      }
      finally{
        this.adding=false
        $('#attendanceModalId').modal('hide');
      }
    }
  }

}

</script>
<style scoped>
.badge {
  .close {
    margin-left: .25rem;
    color: inherit;
    font-size: 100%;
    text-shadow: 0 1px 0 rgba(#000, .5);
  }
}
.scroll-area-attendance {
  position: relative;
  max-height: 153px;
  overflow: hidden;
}
.border-grey{
  border-color: #dee2e6!important
}
</style>
